// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3VyCL","requiredAsterisk":"Info_requiredAsterisk__2PAeS"};